import { router } from '@inertiajs/vue3';
import { ref, Ref, onMounted, onUnmounted, inject, watch } from 'vue';

export const isDirty: Ref<boolean> = ref(false);
export const removeTracking: any = ref(null);
export const targetUrl: Ref<URL> = ref(null);

export function finishTracking() {
  isDirty.value = false;
  removeTracking.value();
}

export function proceed() {
  finishTracking();
  router.visit(targetUrl.value);
}

export function useTrackModifications() {
  const {
    openNotSavedModal,
  } = inject('registerTracking');

  onMounted(() => {
    removeTracking.value = router.on('before', (event) => {
      if (isDirty.value && event.detail.visit.method === 'get') {
        event.preventDefault();
        targetUrl.value = event.detail.visit.url;
        openNotSavedModal.value = true;
      }
    });
  });

  onUnmounted(() => {
    finishTracking();
  });

  /**
   * We will use this method to track modifications and know
   * when to set dirty to true.
   *
   * @param {function} callable
   */
  function trackModificationOn(callable: () => boolean) {
    watch(callable, (newValue: boolean) => {
      if (newValue === true) {
        isDirty.value = true;
      }
    });
  }

  return {
    trackModificationOn,
  };
}
